import React, { Component } from "react";
import { Button, Form, Modal ,InputGroup } from "react-bootstrap";
import AuthService from "../../session/AuthService";
import ManageUserService from "../../api/ManageUserService";
import DatePicker from "react-multi-date-picker";





class NotificationFilterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterby: "",
      colorChange2: false,
      colorChange3 : false,
      commonFilterArray :[]
    };
  }



  render() {
     
    const { colorChange2  ,colorChange3 } = this.state;

    return (
      <>
        <Modal show={this.props.show} onHide={this.props.handleClose}>
          <Modal.Header closeButton>
            <span style={{fontWeight : "bolder"}}>Filter Notification </span>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Filter </Form.Label>
              <select
                class="form-select form-select-sm"
                aria-label=".form-select-sm example"
                id="form-select-sm-employee"
                name="filterby"
                value={this.state.filterby}
                onChange={this.onFilterByChange}
                style={{ color: colorChange2 ? "black" : "#747c84" }}
              >
                <option selected>Choose</option>
        
                <option value={"Employee"}>Employee</option>
                <option value={"date"}>Date</option>
              </select>
            </Form.Group>
            {this.state.filterby === "Employee" && (
                 <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                 <Form.Label>Filter By</Form.Label>
                 <select
                   class="form-select form-select-sm"
                   aria-label=".form-select-sm example"
                   id="form-select-sm-employee"
                   name="filterValue"
                   value={this.state.filterValue}
                   onChange={this.onFilterByChangeValue}
                   style={{ color: colorChange3 ? 'black' : '#747c84' }}
                 >
                   <option>{"Choose"}</option>
             
                    
                    {this.state.commonFilterArray.map((e) => (
                      <option key={e.id} value={`${e.firstName}`}>
                      {`${e.firstName} ${e.lastName || ""}`}
                    </option>
                     ))}
                
                   
                 </select>
               </Form.Group>
            )}
            
            {this.state.filterby === "date" && (
              <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Task Date</Form.Label>
                <InputGroup>
                <DatePicker
                    format="YYYY-MM-DD"
                    placeholder="Choose Task Date"
                    value={this.state.filterValue}
                    name="resourseDate"
                    onChange={(e) => this.handleDateChange(e)}
                    style={{
                      height: "35px",
                      backgroundColor: "#F3F4F1",
                      borderColor: "#F3F4F1",
                    }}
                     
                 
                  />
                  <InputGroup.Append>
                    <i
                      className="fa fa-calendar"
                      style={{
                        position: "absolute",
                        left: "15rem",
                        top: "10px",
                        color: "rgb(138, 188, 73)",
                      }}
                    ></i>
                  </InputGroup.Append>
                </InputGroup>
              </Form.Group>
            )}
            
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.clearFilter}>
              Clear filter
            </Button>
            <Button variant="success" onClick={this.applyFilter}>
              {"Apply Filter"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }



 

  onFilterByChange = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
        colorChange2 : true
      },
      () => {
          if (this.state.filterby === "Employee") {
          this.togetEmployeeFilter();
          this.props.getfilterType(this.state.filterby);
        } else {
          this.props.getfilterType(this.state.filterby);
        }
      }
    );
  };


  handleDateChange = (date) => {
    if (date) { // Check if date is not null or undefined
      console.log("date", date.toString());
  
      this.setState(
        {
            filterValue: date.toString(),
        }
      );
    }
  };




  togetEmployeeFilter = () => {
    let obj = { group_id: parseInt(AuthService.getUserId()) };

    ManageUserService.getAllUserData(obj).then((response) => {
      console.log("response in userData", response);
      if (response.data && response.data.data) {
        this.setState({
          commonFilterArray: response.data.data.UserData,
        },() => {
            console.log("userData" , this.state.commonFilterArray)
        });
      }
    });
  };

  onFilterByChangeValue = (event) => {
    
      this.setState({
        filterValue : event.target.value,
        colorChange3 : true
      })
  }

  applyFilter = () => {
  
    this.props.filterdata(this.state.filterValue)
    this.props.handleClose();



  };

  clearFilter = () => {
    this.props.clearfilter();
    this.props.handleClose();
  }

}
export default NotificationFilterModal;